var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup380291(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75571 23.7179C2.76332 24.7596 4.39007 24.7596 5.39768 23.7179L21.1795 7.40196C22.1871 6.36025 22.1871 4.67846 21.1795 3.63675C20.1719 2.59504 18.5452 2.59504 17.5376 3.63675L1.75571 19.9527C0.748097 20.9944 0.748097 22.6762 1.75571 23.7179Z",
    stroke: "url(#paint0_linear_1859_9)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3715 9.27302L15.7295 5.50781",
    stroke: "url(#paint1_linear_1859_9)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82489 1.05223L9.64587 0.5L9.11172 2.3826L9.64587 4.26521L7.82489 3.71298L6.00391 4.26521L6.53806 2.3826L6.00391 0.5L7.82489 1.05223Z",
    stroke: "url(#paint2_linear_1859_9)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96942 8.58348L4.79041 8.03125L4.25625 9.91385L4.79041 11.7965L2.96942 11.2442L1.14844 11.7965L1.68259 9.91385L1.14844 8.03125L2.96942 8.58348Z",
    stroke: "url(#paint3_linear_1859_9)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1794 14.8589L23.0004 14.3066L22.4662 16.1892L23.0004 18.0719L21.1794 17.5196L19.3584 18.0719L19.8926 16.1892L19.3584 14.3066L21.1794 14.8589Z",
    stroke: "url(#paint4_linear_1859_9)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1859_9",
    x1: 11.4676,
    y1: 2.85547,
    x2: 11.4676,
    y2: 24.4991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0466C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#720BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1859_9",
    x1: 17.5505,
    y1: 5.50781,
    x2: 17.5505,
    y2: 9.27302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0466C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#720BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1859_9",
    x1: 7.82489,
    y1: 0.5,
    x2: 7.82489,
    y2: 4.26521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0466C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#720BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1859_9",
    x1: 2.96942,
    y1: 8.03125,
    x2: 2.96942,
    y2: 11.7965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0466C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#720BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1859_9",
    x1: 21.1794,
    y1: 14.3066,
    x2: 21.1794,
    y2: 18.0719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0466C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#720BF5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup380291);
export default __webpack_public_path__ + "static/media/Group 38029 (1).ca9b268e.svg";
export { ForwardRef as ReactComponent };